/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Therapeutic_Massage_TermsInputs */

const en_service_type_therapeutic_massage_terms = /** @type {(inputs: Service_Type_Therapeutic_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`massage, back massage, neck massage, back pain, tension`)
};

const pl_service_type_therapeutic_massage_terms = /** @type {(inputs: Service_Type_Therapeutic_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masaż, masaż kręgosłupa, masaż pleców, masaż karku, ból pleców, napięcie`)
};

/**
* | output |
* | --- |
* | "massage, back massage, neck massage, back pain, tension" |
*
* @param {Service_Type_Therapeutic_Massage_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_therapeutic_massage_terms = /** @type {((inputs?: Service_Type_Therapeutic_Massage_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Therapeutic_Massage_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_therapeutic_massage_terms(inputs)
	return en_service_type_therapeutic_massage_terms(inputs)
});